import React from 'react';
import { withTranslation } from 'react-i18next';
import { RootState } from 'data/root.reducers';
import { connect } from 'react-redux';
import * as discoverySelectors from 'xcipio/discovery-xcipio-selectors';
import * as cspConfigSelectors from 'data/cspConfig/cspConfig.selectors';
import * as cspConfigActions from 'data/cspConfig/cspConfig.actions';
import { getSelectedDeliveryFunctionId } from 'global/global-selectors';
import { isMultitenantEnabled } from 'data/supportedFeatures/supportedFeatures.selectors';
import { FormTemplateFieldMap } from 'data/template/template.types';
import DynamicForm from '../../shared/form';
import teamCreate from './team-create-form.json';
import PopUp from '../../shared/popup/dialog';
import { AppToaster } from '../../shared/toaster';
import getTeamDataToSubmit from '../utils/teamDataToSubmit';
import getCspOptions from '../utils/getCspOptions';
import { isCspOnlyAdmin, getUserCspId, getUserCspOptions } from '../utils/cspAdminUtils';

export class TeamCreate extends React.Component<any, any> {
  private ref: React.RefObject<DynamicForm>;

  constructor(props: any) {
    super(props);
    this.ref = React.createRef();
    this.state = {
      isOpen: true,

    };
  }

  componentDidUpdate(prevProps: any) {
    if (prevProps.deliveryFunctionId !== this.props.deliveryFunctionId) {
      this.loadCspConfigs();
    }
  }

  loadCspConfigs = () => {
    const { deliveryFunctionId } = this.props;
    if (deliveryFunctionId) {
      this.props.getCspConfigList(deliveryFunctionId);
    }
  }

  getFields = () => {
    const { fields } = teamCreate.forms;
    const { data: users = [] } = this.props.users.users;
    fields.members.options = users.map((element: any) => {
      return { label: element.userID, value: element.userID };
    });

    if (this.isCspOnlyAdmin()) {
      // A CSP-only admin always creates teams under their own CSP
      Object.assign(fields.cspid, {
        options: getUserCspOptions(this.props.cspConfigs, this.getUserCspId()),
        disabled: true,
        preventAutoSelect: false,
      });
    } else {
      Object.assign(fields.cspid, {
        options: getCspOptions(this.props.cspConfigs),
        disabled: !this.props.isMultitenantEnabled,
        preventAutoSelect: true,
      });
    }

    return fields;
  }

  isCspOnlyAdmin = () => isCspOnlyAdmin(this.props.authentication?.privileges);

  getUserCspId = () => getUserCspId(this.props.teams?.teams, this.props.authentication?.userDBId);

  componentDidMount() {
    this.props.getAllUsers();
    this.loadCspConfigs();
  }

  handleSubmit = () => {
    AppToaster.clear();
    if (!this.ref.current ||
      this.ref.current.isValid(true) === false) {
      return;
    }

    const users = this.props.users.users.data;
    const newTeamContent = this.ref.current.getValues();
    if (this.isCspOnlyAdmin()) {
      newTeamContent.cspid = this.getUserCspId();
    }
    const body = getTeamDataToSubmit(
      newTeamContent,
      users,
      '0',
      null,
      this.props.isAuditEnabled,
      this.props.authentication.userDBId,
      this.props.authentication.userId,
    );
    this.props.createTeamAndRefresh(body, this.props.history);
  }

  handleClose = () => {
    AppToaster.clear();
    this.setState({ isOpen: false });
    this.props.history.goBack();
  }

  render() {
    const { t } = this.props;

    return (
      <PopUp title={t('team.create.title')} isOpen={this.state.isOpen} onSubmit={this.handleSubmit} handleClose={this.handleClose} width="500px" {...this.props}>
        <DynamicForm
          name={teamCreate.key}
          ref={this.ref}
          fields={this.getFields() as FormTemplateFieldMap}
          layout={teamCreate.forms.metadata.layout.rows}
          colWidth={6}
          onSubmit={this.handleSubmit}
          i18nKeyPrefix="team.form"
          {...this.props}
        />
      </PopUp>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  authentication: state.authentication,
  roles: state.roles,
  isAuditEnabled: discoverySelectors.isDiscoverySettingAuditEnabled(state),
  deliveryFunctionId: getSelectedDeliveryFunctionId(state),
  cspConfigs: cspConfigSelectors.getCspConfigList(state),
  isMultitenantEnabled: isMultitenantEnabled(state),
});

const mapDispatchToProps = {
  getCspConfigList: cspConfigActions.getCspConfigList,
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(TeamCreate));
